import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import React from 'react';
// import { useTranslation } from 'react-i18next'; // No se usa actualmente
import { FiltersSection } from '../interaction';
import { TotalResults } from '@shared/components/ui/TotalResults';

interface CartsHeaderProps {
  onSearch: (searchTerm: string) => void;
  onFilterChange: (conditions: FilterConditionOutput[]) => void;
  total: number;
}

const CartsHeader: React.FC<CartsHeaderProps> = ({ onSearch, onFilterChange, total }) => {
  // const { t } = useTranslation('cartsModule'); // No se usa actualmente

  return (
    <div className="mb-4">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        {/* Filtros y búsqueda - Filters section */}
        <div className="flex items-center gap-3 flex-wrap">
          <FiltersSection handleSearch={onSearch} onFilterChange={onFilterChange} />
        </div>
        {/* Contador total de resultados - Total results counter */}
        <div className="shrink-0">
          <TotalResults total={total} />
        </div>
      </div>
    </div>
  );
};

export default CartsHeader;
